export var ACTION_BUTTON_WIDTH = 20;
export var TABLE_HEADER_BUTTON_BORDER_WIDTH = 2;
export var TABLE_HEADER_BUTTON_BORDER_COLOR = 'primary70';
export var TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = 'primary80';
export var TABLE_HEADER_BUTTON_SORT_ICON_COLOR = 'primary70';